module.exports = __webpack_public_path__ + "static/img/icon_wududao@2x.fa2784f7.png";